import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'label', pure: false })
export class LabelPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }


  private readonly map: Record<
    'type' | 'status',
    Record<string, string>
  > = {
      type: {
        'VENDA': 'common.deposit',
        'SAQUE': 'common.withdraw'
      },
      status: {
        'PENDENTE': 'common.pending',
        'ANALISE': 'common.analysis',
        'EM PROCESSAMENTO': 'common.inProcess',
        'REALIZADO': 'common.completed',
        'CANCELADO': 'common.canceled',
        'ERRO': 'common.error',
        "AWAITINGPAYMENT": "Awaiting Payment",
        "CREATELINK": "Create Link"
      },
    };

  transform(value: string, group: 'type' | 'status'): string {
    if (!value) { return ''; }

    const keySrc = value.trim().toUpperCase();
    const dictKey = this.map[group][keySrc];

    return dictKey ? this.translate.instant(dictKey) : value;
  }
}
